var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.place || _vm.value || _vm.visible)?_c('div',{staticClass:"cx_layer",style:({zIndex:_vm.zIndex, display:_vm.value || _vm.visible ? _vm.display:'none'})},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }